/* FOM · workspace CONHECIMENTO & EVIDENCIA — sabemos · acreditamos · nao
   sabemos · planejamos, como camada de conhecimento operacional.

   Cada item e um dado REAL do mapa (know/gaps/st dos nos ativos), com a
   classe epistemica escrita. A grade de "readiness" diz, dimensao a
   dimensao, onde o conhecimento e estruturado, parcial ou texto livre — e
   uma leitura da arquitetura (FOM-ARQ-0066 §19), nao um dado do banco. */
import type { FomNode, Relation, StatusClass } from '../core/types.ts';
import { COR_ST, ROTULO_ST } from '../core/types.ts';
import { ehFuturo } from '../core/lentes.ts';
import { el, botao } from './dom.ts';

export type ConhecimentoOpcoes = {
  aoIrParaNo: (externalId: string) => void;
  aoInvestigarLacuna: (no: FomNode, lacuna: string) => void;
  aoAbrirEvidencia: (no: FomNode) => void;
  papel: () => string;
  aoFechar: () => void;
};

const READINESS: { dim: string; estado: 's' | 'p' | 'n'; onde: string }[] = [
  { dim: 'WHAT', estado: 's', onde: '13 tipos · hierarquia' },
  { dim: 'EVIDENCE', estado: 's', onde: '7 classes · teto no banco' },
  { dim: 'STATE', estado: 's', onde: 'layer · TO-BE' },
  { dim: 'PROVENANCE', estado: 's', onde: 'origem · trilha · ator' },
  { dim: 'WHO', estado: 'p', onde: 'funcao · resp so USER' },
  { dim: 'WHY', estado: 'p', onde: 'resumo · missao (texto)' },
  { dim: 'HOW', estado: 'p', onde: 'ordinal · step_kind livre' },
  { dim: 'WHEN', estado: 'p', onde: 'precond · trigger (texto)' },
  { dim: 'RULES', estado: 'p', onde: 'contrato · guia' },
  { dim: 'EXCEPTIONS', estado: 'p', onde: 'contrato (texto)' },
  { dim: 'AUTHORITY', estado: 'p', onde: 'fonte: texto livre' },
  { dim: 'HANDOFF', estado: 'p', onde: 'relacao em texto livre' },
  { dim: 'DEPENDENCIES', estado: 'p', onde: 'relacao em texto livre' },
  { dim: 'OUTCOME', estado: 'p', onde: 'saidas (texto)' },
  { dim: 'LIMITS', estado: 'n', onde: 'so na politica do agente' },
];

function chip(st: StatusClass): HTMLElement {
  const c = el('span', 'ev-chip ev-' + st, ROTULO_ST[st]);
  c.style.setProperty('--cor', COR_ST[st]);
  return c;
}

export function montarConhecimento(host: HTMLElement, o: ConhecimentoOpcoes) {
  host.classList.add('superficie-conhecimento');
  host.hidden = true;
  host.setAttribute('role', 'region');
  host.setAttribute('aria-label', 'Conhecimento e evidencia');

  function render(nos: FomNode[], _relacoes: Relation[], foco: 'sabemos' | 'lacunas' | null = null): void {
    host.innerHTML = '';
    const ativos = nos.filter((n) => !n.removed_at);
    const itens: { no: FomNode; st: StatusClass; texto: string; origin?: string }[] = [];
    for (const n of ativos) for (const k of n.know) itens.push({ no: n, st: k.st, texto: k.text, origin: k.origin });
    const gaps: { no: FomNode; g: string }[] = [];
    for (const n of ativos) for (const g of n.gaps) gaps.push({ no: n, g });
    const futuros = ativos.filter((n) => ehFuturo(n));

    const cab = el('header', 'cc-cabecalho');
    const t = el('div');
    t.appendChild(el('p', 'cc-eyebrow', 'Workspace · Conhecimento & Evidencia'));
    t.appendChild(el('h1', 'cc-titulo', 'Sabemos · acreditamos · nao sabemos · planejamos'));
    t.appendChild(el('p', 'cc-sub', 'Cada item e um dado real do mapa, com a classe escrita. Cor epistemica e dado; nunca decora interface. TO-BE nunca conta como atual; relato e hipotese nunca viram fato.'));
    cab.appendChild(t);
    const acoes = el('div', 'cc-acoes');
    acoes.appendChild(botao('Voltar ao mapa · Esc', o.aoFechar, 'botao botao-principal'));
    cab.appendChild(acoes);
    host.appendChild(cab);

    const grade = el('div', 'conh-grade');
    const quad = (id: string, titulo: string, cor: string, sub: string, total: number, corpo: (ul: HTMLElement) => void): HTMLElement => {
      const c = el('section', 'cardx conh-quad');
      c.id = 'conh-' + id;
      const ch = el('div', 'ch');
      const h = el('h2', 'h3', titulo);
      h.style.borderLeft = '3px solid ' + cor;
      h.style.paddingLeft = '8px';
      ch.appendChild(h);
      ch.appendChild(el('span', 'mono xs muted', String(total)));
      c.appendChild(ch);
      c.appendChild(el('p', 'cc-nota', sub));
      const ul = el('ul', 'evidencia-lista');
      corpo(ul);
      if (!ul.childElementCount) ul.appendChild(el('li', 'evidencia-vazio', 'Nada registrado nesta categoria.'));
      c.appendChild(ul);
      return c;
    };
    const linhaKnow = (it: { no: FomNode; st: StatusClass; texto: string; origin?: string }): HTMLElement => {
      const li = el('li');
      li.appendChild(chip(it.st));
      const b = el('button', 'evidencia-link conh-item');
      b.type = 'button';
      b.textContent = it.texto;
      b.title = 'ir para ' + it.no.name;
      b.addEventListener('click', () => o.aoIrParaNo(it.no.external_id));
      li.appendChild(b);
      li.appendChild(el('span', 'evidencia-origem', `${it.no.name} · ${it.origin === 'user' ? 'investigado (USER)' : 'BASE consolidada'}`));
      return li;
    };
    const LIMITE = 40;
    const sabemos = itens.filter((i) => i.st === 'E1' || i.st === 'E2');
    const acreditamos = itens.filter((i) => i.st === 'E3' || i.st === 'E4');
    grade.appendChild(quad('sabemos', 'Sabemos', COR_ST.E1, 'E1 comprovado · E2 documental parcial. Sempre com referencia a um clique.', sabemos.length, (ul) => {
      for (const it of sabemos.slice(0, LIMITE)) ul.appendChild(linhaKnow(it));
      if (sabemos.length > LIMITE) ul.appendChild(el('li', 'cc-nota', `e mais ${sabemos.length - LIMITE}`));
    }));
    grade.appendChild(quad('acreditamos', 'Acreditamos', COR_ST.E3, 'E3 relato do operador · E4 hipotese. O sistema nunca promove por si.', acreditamos.length, (ul) => {
      for (const it of acreditamos.slice(0, LIMITE)) ul.appendChild(linhaKnow(it));
      if (acreditamos.length > LIMITE) ul.appendChild(el('li', 'cc-nota', `e mais ${acreditamos.length - LIMITE}`));
    }));
    grade.appendChild(quad('lacunas', 'Nao sabemos', COR_ST.ND, 'Lacunas declaradas. O unico estado com acao primaria: investigar.', gaps.length, (ul) => {
      const escreve = o.papel() !== 'viewer';
      for (const it of gaps.slice(0, LIMITE)) {
        const li = el('li');
        li.appendChild(chip('ND'));
        const b = el('button', 'evidencia-link conh-item');
        b.type = 'button';
        b.textContent = it.g;
        b.title = 'ir para ' + it.no.name;
        b.addEventListener('click', () => o.aoIrParaNo(it.no.external_id));
        li.appendChild(b);
        const inv = botao('Investigar', () => o.aoInvestigarLacuna(it.no, it.g), 'botao botao-investigar');
        if (!escreve) { inv.disabled = true; inv.title = 'Disponivel para Editor ou Owner.'; }
        li.appendChild(inv);
        li.appendChild(el('span', 'evidencia-origem', it.no.name));
        ul.appendChild(li);
      }
      if (gaps.length > LIMITE) ul.appendChild(el('li', 'cc-nota', `e mais ${gaps.length - LIMITE}`));
    }));
    grade.appendChild(quad('planejamos', 'Planejamos', COR_ST.TOBE, 'TO-BE: intencao declarada. Nunca conta como atual.', futuros.length, (ul) => {
      for (const n of futuros.slice(0, LIMITE)) {
        const li = el('li');
        li.appendChild(chip('TOBE'));
        const b = el('button', 'evidencia-link conh-item');
        b.type = 'button';
        b.textContent = n.name;
        b.addEventListener('click', () => o.aoIrParaNo(n.external_id));
        li.appendChild(b);
        li.appendChild(el('span', 'evidencia-origem', n.origin === 'base' ? 'BASE congelada' : 'criado por voce'));
        ul.appendChild(li);
      }
      if (futuros.length > LIMITE) ul.appendChild(el('li', 'cc-nota', `e mais ${futuros.length - LIMITE}`));
    }));
    host.appendChild(grade);

    const rd = el('section', 'cardx');
    const rch = el('div', 'ch');
    rch.appendChild(el('h2', 'h3', 'Onde o conhecimento e estruturado e onde e texto'));
    rch.appendChild(el('span', 'cc-tag cc-tag-arch', 'readiness'));
    rd.appendChild(rch);
    const g = el('div', 'readiness');
    for (const r of READINESS) {
      const d = el('div', r.estado);
      d.appendChild(el('b', undefined, r.dim));
      d.appendChild(el('span', undefined, `${r.estado === 's' ? 'estruturado' : r.estado === 'p' ? 'parcial' : 'nao estruturado'} · ${r.onde}`));
      g.appendChild(d);
    }
    rd.appendChild(g);
    rd.appendChild(el('p', 'cc-nota', 'Leitura da arquitetura (FOM-ARQ-0066 §19). Lacunas de semantica influenciam o design e dependem de futuro gate de arquitetura de conhecimento; nada e inventado aqui.'));
    host.appendChild(rd);

    if (foco) {
      const alvo = host.querySelector('#conh-' + foco) as HTMLElement | null;
      if (alvo && typeof alvo.scrollIntoView === 'function') {
        requestAnimationFrame(() => alvo.scrollIntoView({ block: 'start', behavior: 'smooth' }));
      }
    }
  }

  return {
    render,
    mostrar(): void { host.hidden = false; },
    esconder(): void { host.hidden = true; },
    get aberta(): boolean { return !host.hidden; },
  };
}
